<!--
 * @Author: leunghope
 * @Date: 2020-09-29 17:16:08
 * @LastEditTime: 2021-02-22 15:07:23
 * @LastEditors: xufangting
 * @Description: 
-->
<template>
  <div id="app">
    <div id="apps">
      <router-view></router-view>
    </div>
    <!-- <img alt="Vue logo" src="./assets/logo.png">
    <HelloWorld msg="Welcome to Your Vue.js App"/>-->
  </div>
</template>

<script>
export default {
  name: "App",
  created() {
    this.$get(this.$api.getConfigInfo).then((res) => {
      localStorage.setItem("config", JSON.stringify(res.data));
      let color = res.data.color_template && res.data.color_template.main_color;
      if (color) {
        document.documentElement.style.setProperty("--theme-color", color);
      }
    });
  },
};

</script>

<style>
html,
body,
#app,
#apps {
  height: 100%;
  margin: 0;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
}
ol,
ul {
  list-style: none;
}
a {
  text-decoration: none;
  color: #333;
}
.qingwu {
  height: 100%;
}

.el-dialog {
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  /*height:600px;*/
  max-height: calc(100% - 30px);
  max-width: calc(100% - 30px);
}
.el-dialog .el-dialog__body {
  flex: 1;
  overflow: auto;
}

.el-dialog__title {
  font-size: 14px !important;
  font-weight: bold;
}
.el-tabs__item.is-active {
  color: #f56c6c !important;
  font-weight: bold;
}
.el-tabs__item:hover {
  color: #f56c6c !important;
}
.el-input__inner {
  border-radius: 0 !important;
  border: 1px solid #dcdcdc !important;
}
</style>
